import type { LoginInput } from '@chukua/common';
import { api } from '../lib/api';

export interface CurrentUser {
  id: string;
  email: string;
  name: string;
  phone: string | null;
  isActive: boolean;
  totpEnabled: boolean;
  createdAt: string;
  updatedAt: string;
  /** The union of every role the user holds. Server remains the authority — this is UX only (CLAUDE.md → Web conventions). */
  permissions: string[];
}

export interface LoginStepUpRequired {
  requiresTotp: true;
}

/** An account owing a forced password change (an admin reset it) gets this instead of a user — the same request, no session yet. */
export interface PasswordChangeRequired {
  passwordChangeRequired: true;
}

/** A TOTP-enabled account gets `requiresTotp` instead of a user — the same request, no session yet. */
export function login(input: LoginInput): Promise<CurrentUser | LoginStepUpRequired | PasswordChangeRequired> {
  return api<CurrentUser | LoginStepUpRequired | PasswordChangeRequired>('/auth/login', { method: 'POST', body: JSON.stringify(input) });
}

export function verifyTotpLogin(code: string): Promise<CurrentUser> {
  return api<CurrentUser>('/auth/totp/verify', { method: 'POST', body: JSON.stringify({ code }) });
}

/** Completes a forced password change; lands the account on the same next step a fresh login would (a TOTP challenge, or straight to a session). */
export function completePasswordChange(password: string): Promise<CurrentUser | LoginStepUpRequired> {
  return api<CurrentUser | LoginStepUpRequired>('/auth/password/complete', { method: 'POST', body: JSON.stringify({ password }) });
}

export function logout(): Promise<void> {
  return api<void>('/auth/logout', { method: 'POST' });
}

export function me(): Promise<CurrentUser> {
  return api<CurrentUser>('/auth/me');
}
